import React from "react";
import {
    Button,
    RichCell
} from "@vkontakte/vkui";
import {
    Icon20DeleteOutline,
    Icon20EditCircleFillBlue
} from "@vkontakte/icons";
import {AdaptivityContext} from "../../assets/constants";
import BaseList from "../../components/BaseList";
import StandCollectionsApi from "../../api/references/standcollections";

class StandCollectionBindingsList extends BaseList {
    canCreateItem() {
        return true
    }

    createItem = () => {
        if (this.props.onCreate) {
            this.props.onCreate()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reloadToken !== this.props.reloadToken) {
            this.doRefresh()
        }
        if (this.props.countPatch && prevProps.countPatch !== this.props.countPatch) {
            const {id, count} = this.props.countPatch
            this.setState({
                items: this.state.items.map(row =>
                    Number(row.id) === Number(id) ? {...row, products_count: count} : row
                )
            })
        }
    }

    getItems = (mainSearch = '', append = false, page = 1) => {
        clearInterval(this.searchInterval)

        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page
        }
        if (mainSearch == '') {
            mainSearch = this.state.mainSearch ?? ''
        }

        StandCollectionsApi.getMatchingCollections({
            search: mainSearch,
            page,
            epp: AdaptivityContext.isMobile ? 10 : 20
        }).then(response => {
            this.setState({loading: false})
            let old = this.state.items
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.forEach((el) => {
                    old.push(el)
                })
            }

            this.setState({
                items: old,
                cnt_items: response.data.iTotalRecords,
                totalPages: response.data.iTotalPages,
            })
            if (this.props.onItems) {
                this.props.onItems(old)
            }

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        }).catch(() => {
            this.setState({loading: false})
        })
    }

    removeItem = async (item, event) => {
        event.stopPropagation()
        event.preventDefault()
        if (!window.confirm(`Удалить коллекцию «${item.title}»?`)) {
            return
        }
        try {
            await StandCollectionsApi.delete(item.id)
            window.postMessage({type: 'success', text: 'Коллекция удалена', timeout: 1500, hideSpinner: true})
            if (this.props.onDeleted) {
                this.props.onDeleted(item)
            }
        } catch (error) {
            window.postMessage({
                type: 'error',
                text: 'Не удалось удалить коллекцию',
                timeout: 3000,
                hideSpinner: true,
            })
        }
    }

    renderRow = (item) => {
        const selected = Number(this.props.selectedId) === Number(item.id)
        const stand = (item.kits && item.kits.length)
            ? item.kits.map(kit => `${kit.stand_title} › ${kit.kit_title}`).join('; ')
            : (item.descr || 'Без стенда')
        return <RichCell
            multiline
            onClick={() => this.props.onSelect && this.props.onSelect(item)}
            style={{
                ...this.getRowStyle(item),
                background: selected ? 'var(--vkui--color_background_secondary_alpha)' : undefined,
                border: selected ? '2px solid orange' : undefined,
                borderRadius: selected ? 8 : undefined,
                cursor: 'pointer',
            }}
            subhead={stand}
            caption={`Товаров: ${item.products_count || 0}`}
            afterCaption={<div style={{display: "flex", flexDirection: "column", gap: 8}} onClick={(event) => event.stopPropagation()}>
                <Button mode="outline" size="s" onClick={() => this.props.onEdit && this.props.onEdit(item)}>
                    <Icon20EditCircleFillBlue/>
                </Button>
                <Button mode="outline" size="s" onClick={(event) => this.removeItem(item, event)}>
                    <Icon20DeleteOutline/>
                </Button>
            </div>}
        >
            {item.title}
        </RichCell>
    }
}

export default StandCollectionBindingsList
